import { render } from "./DashboardContainer.vue?vue&type=template&id=2022e8b0&lang=true"
const script = {}

import "./DashboardContainer.vue?vue&type=style&index=0&id=2022e8b0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__